// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 15px 30px;
  border-bottom: 2px solid #ddd;
  width: 100%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  position: relative;
  z-index: 20000;
  overflow: visible;
}

.logo-container {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.company-logo {
  max-height: 60px;
  margin-right: 15px;
  max-width: 100%;
}

.nav-links {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  overflow: visible;
}

.nav-links a,
.runtime-menu-button {
  text-decoration: none;
  color: #007bff;
  font-size: 18px;
  font-weight: bold;
  white-space: nowrap;
}

.nav-links a:hover,
.runtime-menu-button:hover {
  color: #0056b3;
  text-decoration: none;
}

.runtime-menu {
  position: relative;
  display: inline-flex;
  align-items: center;
  overflow: visible;
}

.runtime-menu-button {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}

.runtime-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  min-width: 220px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18);
  padding: 6px;
  z-index: 30000;
}

.runtime-dropdown-item,
.runtime-empty {
  display: block;
  padding: 9px 10px;
  border-radius: 8px;
  color: #111827 !important;
  text-decoration: none !important;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
}

.runtime-dropdown-item:hover {
  background: #eff6ff;
  color: #111827 !important;
}

.runtime-empty {
  color: #6b7280 !important;
}

.logout-button {
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 9px 16px;
  font-weight: bold;
  cursor: pointer;
}

.logout-button:hover {
  background-color: #0056b3;
}

@media screen and (max-width: 768px) {
  .app-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .nav-links {
    flex-direction: column;
    gap: 10px;
  }

  .runtime-dropdown {
    left: 50%;
    transform: translateX(-50%);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;AACF","sourcesContent":["body,\nhtml {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n}\n\n.app-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #ffffff;\n  padding: 15px 30px;\n  border-bottom: 2px solid #ddd;\n  width: 100%;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n  position: relative;\n  z-index: 20000;\n  overflow: visible;\n}\n\n.logo-container {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.company-logo {\n  max-height: 60px;\n  margin-right: 15px;\n  max-width: 100%;\n}\n\n.nav-links {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  overflow: visible;\n}\n\n.nav-links a,\n.runtime-menu-button {\n  text-decoration: none;\n  color: #007bff;\n  font-size: 18px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.nav-links a:hover,\n.runtime-menu-button:hover {\n  color: #0056b3;\n  text-decoration: none;\n}\n\n.runtime-menu {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  overflow: visible;\n}\n\n.runtime-menu-button {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n}\n\n.runtime-dropdown {\n  position: absolute;\n  top: calc(100% + 12px);\n  left: 0;\n  min-width: 220px;\n  background: #ffffff;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18);\n  padding: 6px;\n  z-index: 30000;\n}\n\n.runtime-dropdown-item,\n.runtime-empty {\n  display: block;\n  padding: 9px 10px;\n  border-radius: 8px;\n  color: #111827 !important;\n  text-decoration: none !important;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.runtime-dropdown-item:hover {\n  background: #eff6ff;\n  color: #111827 !important;\n}\n\n.runtime-empty {\n  color: #6b7280 !important;\n}\n\n.logout-button {\n  background-color: #007bff;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  padding: 9px 16px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.logout-button:hover {\n  background-color: #0056b3;\n}\n\n@media screen and (max-width: 768px) {\n  .app-header {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .nav-links {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .runtime-dropdown {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
